import { render, staticRenderFns } from "./StreamerWorkbench.vue?vue&type=template&id=8803be78&scoped=true"
import script from "./StreamerWorkbench.vue?vue&type=script&lang=js"
export * from "./StreamerWorkbench.vue?vue&type=script&lang=js"
import style0 from "./StreamerWorkbench.vue?vue&type=style&index=0&id=8803be78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8803be78",
  null
  
)

export default component.exports